var splice = require('./splice');

module.exports = function insert(str, i, substr) {
  return splice(str, i, 0, substr);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore.string/insert.js
// module id = 804
// module chunks = 0